<style lang="less" scoped>
.hyxqDetails{position: relative;width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;margin-top: 20px;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 60px;}
.national{width: 1200px;}
.first{display: flex;justify-content:space-between;width: 1200px;margin:auto;}
.second{width: 830px;margin-right: 20px;}
.third{display: flex;flex-direction: column;width: 350px;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 19px;color: rgb(25, 159, 248);}
.details {text-align: left;}
.relatedInfo {margin-top: 30px;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 20px;color: rgb(25, 159, 248);}
.latestnews{margin-top: 48px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 3px;font-size: 18px;color: rgb(25, 159, 248);}
}
.ListZX{margin-left: -32px;margin-top: 0px;text-align: left;}
.hotnews{margin-top: 15px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: baseline;float: left;margin-left: -5px;margin-right: -2px;font-size: 19px;color: rgb(25, 159, 248);}
}
.hotNewsList{margin-left: -34px;margin-top: 0px;text-align: left;}
.reading{margin-top: 15px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.ListYD{margin-left: -32px;margin-top: 0px;text-align: left;}
</style>

<template>
  <div class="hyxqDetails">
    <div class="first">
      <div class="second">
        <Details class="details"></Details>
      </div>
      <div class="third">
        <div class="hotnews">
          <i class="iconfont icon-zuirehotchunse" />
          <span>热门资讯 / Hot news</span>
        </div>
        <HotNewsList class="hotNewsList" :hotNewsList="hotNewsdata" @clickHotNews="goDetails"></HotNewsList>
        <div class="reading">
          <i class="iconfont icon-tubiao303" />
          <span>推荐阅读 / Recommended reading</span>
        </div>
        <List class="ListYD" :List="readingdata" @clickListNews="goDetails"></List>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽
 * 矿业资讯 公共部分页面
 */
import National from '../assembly/National.vue'
import Details from '../assembly/Details.vue'
import List from '../assembly/List.vue'
import HotNewsList from '../assembly/HotNewsList.vue'
import arrayFun from '../method/array.js'
export default {
  components: {
    National,
    Details,
    List,
    HotNewsList
  },
  name: '',
  data()
  {
    return {
      hotNewsdata: [], // 热门资讯
      readingdata: [] // 推荐阅读
    }
  },
  created()
  {
    this.gethyxq()
  },
  methods: {
    gethyxq()
    {
      let paras6 = {cmd: 'query', _major: 11, _minor: 50, _exp: 'addtime>0 and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 50}
      window.post.getPost(paras6).then((ret) =>
      {
        this.hotNewsdata = ret[0].data.sort(arrayFun.compareBtoS('hits'))  // 热门资讯
        this.readingdata = ret[0].data  // 推荐阅读
      })
    },
    // 跳转到大会资讯详情页面，并将被点击的新闻的id传递到详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/HyxqDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/HyxqDetails.vue